import { GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import HiddenBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/issuable/components/hidden_badge.vue?vue3';
import LockedBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/issuable/components/locked_badge.vue?vue3';
import ArchivedBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/issuable/components/archived_badge.vue?vue3';
import { NAMESPACE_PROJECT } from '~/issues/constants';
import ConfidentialityBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/confidentiality_badge.vue?vue3';
import ImportedBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/imported_badge.vue?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import WorkItemTypeIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/work_item_type_icon.vue?vue3';
import { findNotesWidget } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/utils.js?vue3';
import WorkItemStateBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/work_item_state_badge.vue?vue3';
export default {
    name: 'WorkItemStickyHeader',
    components: {
        HiddenBadge,
        ImportedBadge,
        LockedBadge,
        ArchivedBadge,
        ConfidentialityBadge,
        WorkItemStateBadge,
        GlLink,
        WorkItemTypeIcon
    },
    directives: {
        SafeHtml
    },
    props: {
        workItem: {
            type: Object,
            required: true
        },
        isDrawer: {
            type: Boolean,
            required: false,
            default: false
        },
        archived: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        isDiscussionLocked () {
            return findNotesWidget(this.workItem)?.discussionLocked;
        },
        workItemType () {
            return this.workItem.workItemType?.name;
        },
        workItemTypeIconName () {
            return this.workItem.workItemType?.iconName;
        },
        workItemState () {
            return this.workItem.state;
        }
    },
    NAMESPACE_PROJECT,
    TITLE_CLASS: 'gl-mr-auto gl-block gl-truncate gl-pr-3 gl-font-bold gl-text-strong',
    titleInLinkSafeHtmlConfig
};
